import { render, staticRenderFns } from "./KeyboardShortcuts.vue?vue&type=template&id=394f4f6c"
import script from "./KeyboardShortcuts.vue?vue&type=script&lang=ts"
export * from "./KeyboardShortcuts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports